var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "add-attribute-wrapper" },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-center align-items-center text-center p-0 mt-1 btnAddAttribute",
          on: { click: _vm.showModal },
        },
        [
          _c(
            "span",
            { staticClass: "material-icons add-custom-attribute-plus" },
            [_vm._v(" add ")]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "m-0 add-custom-attribute-p" }, [
            _vm._v(_vm._s(_vm.$t("chatbotv2.addAttribute"))),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: "",
            wrapClassName: "vertical-center-modal",
            id: "add-custom-attr-modal",
            "confirm-loading": _vm.loading,
          },
          on: { ok: _vm.handleOk },
          model: {
            value: _vm.modalVisible,
            callback: function ($$v) {
              _vm.modalVisible = $$v
            },
            expression: "modalVisible",
          },
        },
        [
          _c("div", { staticClass: "add-custom-attribute-restriction row" }, [
            _c("div", { staticClass: "col-xs-2" }, [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v(" help_outline "),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-10 text-wrap" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("chatbotv2.addAttributeDescription")) +
                  "\n            "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("Attribute Name")]),
          _vm._v(" "),
          _c("a-input", {
            attrs: { placeholder: "Type attribute name" },
            on: {
              keydown: function ($event) {
                return _vm.checkKeyDownAlphaNumeric($event)
              },
            },
            model: {
              value: _vm.customAttribute,
              callback: function ($$v) {
                _vm.customAttribute = $$v
              },
              expression: "customAttribute",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }